import { createAction } from '@reduxjs/toolkit';

// Action to track assistant queries in PostHog
const trackAssistantQuery = createAction<{ query: string }>(
  'assistant/trackQuery'
);

// Action to track assistant command actions in PostHog
const trackAssistantAction = createAction<{
  actionType: string;
  actionName: string;
  query?: string;
}>('assistant/trackAction');

export default {
  trackAssistantQuery,
  trackAssistantAction,
};
